type PendingNavigation = {
  fromMemberId: string | null;
  toMemberId: string | null;
};

type TeamMemberBioDrawerPresentationInput = {
  activeMemberId: string | null;
  closingMemberId: string | null;
  isClosing: boolean;
  pendingNavigation: PendingNavigation;
  suppressedNavigationMemberId: string | null;
};

type TeamMemberBioDrawerPresentationMode = "closing" | "navigating" | "synced";

type TeamMemberBioDrawerPresentation = {
  displayedMemberId: string | null;
  isOpen: boolean;
  mode: TeamMemberBioDrawerPresentationMode;
};

function getTeamMemberBioDrawerPresentation({
  activeMemberId,
  closingMemberId,
  isClosing,
  pendingNavigation,
  suppressedNavigationMemberId,
}: TeamMemberBioDrawerPresentationInput): TeamMemberBioDrawerPresentation {
  const isUrlStillOnClosingMember =
    activeMemberId === null || activeMemberId === closingMemberId;
  const shouldSuppressLateNavigationTarget =
    suppressedNavigationMemberId !== null &&
    activeMemberId === suppressedNavigationMemberId;

  if (
    isClosing &&
    (isUrlStillOnClosingMember || shouldSuppressLateNavigationTarget)
  ) {
    return {
      displayedMemberId: closingMemberId,
      isOpen: false,
      mode: "closing",
    };
  }

  const isAwaitingNavigationUrl =
    !isClosing &&
    pendingNavigation.toMemberId !== null &&
    activeMemberId === pendingNavigation.fromMemberId;

  if (isAwaitingNavigationUrl) {
    return {
      displayedMemberId: pendingNavigation.toMemberId,
      isOpen: true,
      mode: "navigating",
    };
  }

  return {
    displayedMemberId: activeMemberId,
    isOpen: activeMemberId !== null,
    mode: "synced",
  };
}

export type {
  PendingNavigation,
  TeamMemberBioDrawerPresentation,
  TeamMemberBioDrawerPresentationMode,
};

export { getTeamMemberBioDrawerPresentation };
